export interface CltPropostalInfo{
    createdAt: string;
  installments: number;
  liquidValue: number;
  partnerComission: number;
  source:  string;
  status: string;
  totalComission: number;
  user_id?:number;
  /** Banco/provedor de origem: 'v8' | 'suma_celcoin' | 'suma_uy3' | 'suma'. */
  bank?: string;
  /** Canal: whatsapp/instagram/evolution/telegram (bot) ou autoclt (site). */
  chatSource?: string;
}

/** Rótulo amigável do banco/provedor para filtros e gráficos. */
export function cltBankLabel(bank?: string): string {
  switch ((bank || '').toLowerCase()) {
    case 'v8': return 'V8';
    case 'suma': return 'Soma';
    case 'suma_celcoin': return 'Soma (Celcoin)';
    case 'suma_uy3': return 'Soma (UY3)';
    default: return bank || 'Desconhecido';
  }
}

export interface CltSupportRowInfo{
    bank: string;
  createdAt: string;
  source: string;
  status: number;
  userSupportId: string | null;
}

export enum CltPropostalStatus{
    formalization='formalization',
  paid='paid',
  canceled='canceled',
  manual_analysis='manual_analysis',
  processing='processing',
  pending='pending'
}